/* src/app/shared/components/ag-drop-down/ag-single-description-box/ag-single-description-box.component.scss */
.disable-selection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-standard {
  position: inherit;
  z-index: 2;
  max-height: 100%;
  height: fit-content;
  width: 100%;
  min-width: 82px;
  border-radius: 12px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  background-color: #ffffff;
  overflow: hidden;
}
.container-fixed {
  padding-right: 8px;
  position: fixed;
  z-index: 100;
  max-height: 100%;
  height: fit-content;
  border-radius: 8px;
  box-shadow: 0 3px 8px 0 rgba(140, 140, 140, 0.5);
  background-color: #ffffff;
}
.items-container {
  width: 100%;
}
.hovering-item {
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
}
.hovering-item.is-selected .item {
  background-color: #d9e2ff;
  border-radius: 8px;
  padding: 8px;
}
.hovering-item:hover .item {
  background-color: #f2f2f2;
  border-radius: 8px;
}
.item {
  width: 100%;
  min-height: 40px;
  background-color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 8px;
}
.checkbox-img {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 2px;
}
.item-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.item-label {
  font-family: "Poppins-Regular";
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  cursor: pointer;
}
.item-label-bold {
  font-family: "Poppins-Medium";
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  cursor: pointer;
}
.item-description {
  font-family: "Poppins-Regular";
  font-size: 12px;
  line-height: 18px;
  color: #5c5c5c;
  cursor: pointer;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dfdfdf;
  margin-bottom: 8px;
}
.top-bottom-padding {
  margin-bottom: 5px;
  padding-bottom: 8px;
  height: fit-content;
  display: block;
  overflow-y: scroll;
  overflow-x: hidden;
}
.form-div {
  position: relative;
  width: 100%;
  padding: 12px;
}
.search-bar {
  display: flex;
  gap: 12px;
  padding: 16px 8px;
  background-color: #f2f2f2;
  border-radius: 12px;
  width: 100%;
  height: 40px;
  align-items: center;
}
.form-img {
  height: 20px;
  width: 20px;
  opacity: 0.5;
}
.search-bar-input {
  width: 95%;
  font-size: 14px;
  border: none;
  background-color: #f2f2f2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 20px;
}
.no-result-text {
  color: #5c5c5c;
  text-align: center;
  font-size: 12px;
  font-family: "Poppins-Regular";
}
input:focus {
  outline: none;
}
::placeholder {
  font-family: "Poppins-Regular";
  font-size: 14px;
  color: #5c5c5c;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #a6a6a6;
  border-radius: 3px;
}
/*# sourceMappingURL=ag-single-description-box.component.css.map */
